/**
 * 品牌
 */

import { HTTP_ALB } from '../axios'

//  品牌列表
export const getplacardlist = params => {
  return HTTP_ALB.get('/system/placard/list', params)
}

// 添加品牌
export const addplacard = params => {
  return HTTP_ALB.post('/system/placard/add', params)
}
// 编辑品牌
export const editplacard = params => {
  return HTTP_ALB.post('/system/placard/edit', params)
}
